/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_UnknownInputs */

const tr_geliver_status_unknown = /** @type {(inputs: Geliver_Status_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilinmiyor`)
};

const en_geliver_status_unknown = /** @type {(inputs: Geliver_Status_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const de_geliver_status_unknown = /** @type {(inputs: Geliver_Status_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannt`)
};

const ru_geliver_status_unknown = /** @type {(inputs: Geliver_Status_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестно`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Geliver_Status_UnknownInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_unknown = /** @type {((inputs?: Geliver_Status_UnknownInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_UnknownInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_unknown(inputs)
	if (locale === "de") return de_geliver_status_unknown(inputs)
	if (locale === "ru") return ru_geliver_status_unknown(inputs)
	return tr_geliver_status_unknown(inputs)
});